module.exports = __webpack_public_path__ + "static/media/image.48eec6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Email2020/image.jpg
// module id = 84
// module chunks = 0